import { Divider } from "antd";
import { BadgeCheck } from "lucide-react";
import React from "react";
import { formatDate } from "../../utils/dateTime";

const OfficialCard = ({ employee }) => {
  // Helper to format time in 12-hour format with AM/PM
  const formatTime12Hour = (timeStr) => {
    if (!timeStr || timeStr === "-" || timeStr === "ss") return "-";
    const [hours, minutes] = timeStr.split(":");
    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour.toString().padStart(2, "0")}:${minutes} ${ampm}`;
  };

  return (
    <div className="w-full rounded-lg flex flex-col gap-2 border-2 border-form-bg border-t-[#231564] shadow-lg px-2 sm:px-3 py-2 sm:py-3 bg-white">
      <div className="flex items-center gap-2 text-black font-semibold">
        <BadgeCheck size={18} sm:size={20} className="text-gray-500" />
        <h2 className="text-sm sm:text-md font-bold pt-3">OFFICIAL</h2>
      </div>
      <Divider className="!p-0 !m-0" />
      <div className="grid grid-cols-2 gap-y-2 sm:gap-y-3 text-sm sm:text-md min-w-0">
        <span className="text-gray-400 text-[10px] sm:text-[11px] ">
          STATUS
        </span>
        <span
          className={` ${employee?.status?.toLowerCase() === 'inactive'
              ? 'bg-red-500'
              : 'bg-green-500'
            } text-white text-center text-xs sm:text-md px-1 sm:px-2 py-[2px] rounded-md w-20 capitalize`}
        >
          {employee?.status || 'N/A'}
        </span>


        <span className="text-gray-400 text-sm sm:text-md ">
          EMPLOYMENT
        </span>
        <span className="font-normal  text-sm sm:text-md capitalize">
          {employee?.employee_type || 'N/A'}
        </span>

        <span className="text-gray-400 text-sm sm:text-md ">
          PAY TYPE
        </span>
        <span className="font-normal  text-sm sm:text-md capitalize">
          {employee?.salary_type || 'N/A'}
        </span>

        <span className="text-gray-400 text-sm sm:text-md ">SHIFT</span>
        <span className="font-normal text-sm sm:text-md capitalize">
          {`${employee?.shift?.shiftName} (${formatTime12Hour(employee?.shift?.startTime)} - ${formatTime12Hour(employee?.shift?.endTime)})`}
        </span>

        <span className="text-gray-400 text-sm sm:text-md ">
          HIRE DATE
        </span>
        <span className="font-normal  text-sm sm:text-md capitalize">
          {employee?.hire_date ? formatDate(employee.hire_date) : 'N/A'}
        </span>

        <span className="text-gray-400 text-sm sm:text-md ">
          JOINING DATE
        </span>
        <span className="font-normal  text-sm sm:text-md capitalize">
          {employee?.joining_date ? formatDate(employee.joining_date) : 'N/A'}
        </span>

        <span className="text-gray-400 text-sm sm:text-md ">
          CONFIRMATION DATE
        </span>
        <span className="font-normal  text-sm sm:text-md capitalize">
          {employee?.p_confirmation_date ? formatDate(employee.p_confirmation_date) : 'N/A'}
        </span>

        <span className="text-gray-400 text-sm sm:text-md ">
          WORK LOCATION
        </span>
        <span className="font-normal  text-sm sm:text-md capitalize">
          {employee?.location?.locationName || 'N/A'}
        </span>

        <span className="text-gray-400 text-sm sm:text-md ">
          DESIGNATION
        </span>
        <span className="font-normal  text-sm sm:text-md capitalize">
          {employee?.designation?.designationName || 'N/A'}
        </span>

        <span className="text-gray-400 text-sm sm:text-md ">
          DEPARTMENT
        </span>
        <span className="font-normal  text-sm sm:text-md capitalize">
          {`${(employee?.department?.name) || 'N/A'}`} ({employee?.department?.subDepartments?.[0]?.name || 'N/A'})
        </span>

      </div>
    </div>
  );
};

export default OfficialCard;
